namespace $.$$ {

	export class $hyoo_intern_company_card extends $.$hyoo_intern_company_card {

	}

}
